<template>
  <div class="game-zl-container">
    <div style="min-height: 625px;">
      <!--头部开始 -->
      <div class="zl-header"
           :style="{background: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),url(https://game.gtimg.cn/images/yxzj/img201606/heroimg/${currentHero.ename}/${currentHero.ename}-mobileskin-1.jpg)`}">
        <van-nav-bar
                v-if="!$inApp"
                title="在线荣耀战力查询"
                left-text="返回"
                left-arrow
                @click-left="onClickLeft"
                class="transparent-nav"
                :border="false"
        ></van-nav-bar>
        
        <!-- 英雄选择区域（初始位置） -->
        <div class="hero-select-div" ref="heroSelectInitial">
          <van-badge :content="isNew(currentHero) ? '新英雄' : ''">
            <van-image
                    style="border: 2px solid white;"
                    @click="showHeroList"
                    width="4.5rem"
                    height="4.5rem"
                    radius="10"
                    :src="`https://game.gtimg.cn/images/yxzj/img201606/heroimg/${currentHero.ename}/${currentHero.ename}.jpg`"
            ></van-image>
          </van-badge>
          <div @click="showHeroList" style="text-align: center; padding: 5px 0;color: white;" class="hero-name">
            <span>{{currentHero.cname}}</span>
            <van-icon name="exchange"></van-icon>
          </div>
        </div>
        
        <!-- 头部战力摘要 -->
        <div class="zl-header-stats" v-if="!loading && filterScores.length">
          <div class="stat-block">
            <div class="stat-value">{{ formatScore(topScore) }}</div>
            <div class="stat-label">榜首战力</div>
          </div>
          <div class="stat-divider"></div>
          <div class="stat-block">
            <div class="stat-value">{{ formatScore(minScore) }}</div>
            <div class="stat-label">最低上榜</div>
          </div>
        </div>
        
        <div class="zl-header-bottom" style="color: white; position: absolute; bottom: 10px; font-size: 0.9rem; margin-left: 2px;">
          <div><p class="zl-query-time">同步时间: <span class="sync-time">{{synDate}}</span><i @click="showSynNotice" class="van-icon van-icon-question-o secondaryQuestionBtn"></i>
          </p></div>
        </div>
      </div>
      <!--头部结束 -->
      
      <!-- 吸顶区域开始 -->
      <div class="sticky-container" :class="{'sticky-active': isSticky}">
        <!-- 吸顶后的英雄区域 -->
        <div class="sticky-hero-container" :style="stickyHeroStyle">
          <van-badge :content="isNew(currentHero) ? '新英雄' : ''">
            <van-image
                    class="sticky-hero-image"
                    @click="showHeroList"
                    :width="heroImageSize"
                    :height="heroImageSize"
                    radius="10"
                    :src="`https://game.gtimg.cn/images/yxzj/img201606/heroimg/${currentHero.ename}/${currentHero.ename}.jpg`"
            ></van-image>
          </van-badge>
          <div @click="showHeroList" class="sticky-hero-name" :style="heroNameStyle">
            <span>{{currentHero.cname}}</span>
            <van-icon name="exchange"></van-icon>
          </div>
        </div>
        
        <!-- 同步时间 -->
        <div class="sticky-sync-time" :style="syncTimeStyle">
          <p class="zl-query-time">
            <span style="display: inline-flex; align-items: center;">同步时间: </span>
            <span class="sync-time" style="display: inline-flex; align-items: center;">{{synDate}}</span>
            <i @click="showSynNotice" class="van-icon van-icon-question-o secondaryQuestionBtn"></i>
          </p>
        </div>
      </div>
      <!-- 吸顶区域结束 -->
      
      <!--中间部分开始-->
      <div class="zl-body">
        <van-tabs v-model="levelActive" :sticky="true" :offset-top="stickyHeaderHeight" @click="changeLevel">
          <van-tab v-for="(levelItem,tabIndex) in cityLevels" :title="levelItem.text" :key="levelItem.value">
            <template v-if="tabIndex===3" #title>
              <van-dropdown-menu>
                <van-dropdown-item v-model="gameAreaId" @change="changeGameArea" @close="closeDropdown"
                                   :options="gameAreaOptions">
                  <template #title>
                    <span class="area-title">{{ currentSystemName }}<van-icon class="area-title-icon" name="wap-nav"></van-icon></span>
                  </template>
                </van-dropdown-item>
              </van-dropdown-menu>
            </template>
            <div class="zl-body-table">
              <table style="width: 100%;" cellspacing="0" cellpadding="0">
                <!-- 列头 -->
                <tr v-if="!showEmpty" class="zl-table-head zl-body-table-td-bottom">
                  <th class="rank-cell">排名</th>
                  <th style="text-align: left; padding-left: 10px;">地区</th>
                  <th class="zl-body-table-td-score">战力</th>
                  <th v-if="splitCols(tabIndex)" class="zl-body-table-td-delta">变动</th>
                  <th class="zl-body-table-detail">趋势</th>
                </tr>
                <!-- 表格骨架屏 -->
                <template v-if="loading">
                  <tr class="skeleton-row zl-body-table-td-bottom" v-for="n in 8" :key="'sk' + n">
                    <td style="width: 40px;"><span class="sk sk-circle"></span></td>
                    <td style="text-align: left; padding-left: 10px;"><span class="sk sk-bar" :style="{width: (45 + (n % 3) * 15) + '%'}"></span></td>
                    <td class="zl-body-table-td-score"><span class="sk sk-bar" style="width: 80%;"></span></td>
                    <td v-if="splitCols(tabIndex)" class="zl-body-table-td-delta"><span class="sk sk-bar" style="width: 70%;"></span></td>
                    <td style="width: 40px;"><span class="sk sk-bar" style="width: 18px;"></span></td>
                  </tr>
                </template>
                <template v-else>
                  <tr class="zl-body-table-td-bottom" v-for="(score, index) in filterScores"
                      :style="index % 2 === 1 ? 'background-color: rgb(248, 248, 248);' : ''"
                      :key="index">
                    <td class="rank-cell">
                      <img v-if="index < 3" class="rank-medal-img" :src="medalIcons[index]" :alt="`第${index+1}名`"/>
                      <span v-else class="rank-num">{{index+1}}</span>
                    </td>
                    <td class="zl-body-table-td-right zl-body-table-td-bottom"
                        style="text-align: left; padding-left: 10px">{{ score.address }}
                    </td>
                    <!-- 金牌/银牌榜: 分数与变动拆分两列; 铜牌榜保持上下堆叠 -->
                    <template v-if="splitCols(tabIndex)">
                      <td class="zl-body-table-td-right zl-body-table-td-bottom zl-body-table-td-score">
                        <span class="score-value">{{ formatScore(score.rank) }}</span>
                      </td>
                      <td class="zl-body-table-td-right zl-body-table-td-bottom zl-body-table-td-delta">
                        <span v-if="deltaInfo(score)"
                              :class="['score-delta', deltaInfo(score).flat ? 'delta-flat' : (deltaInfo(score).up ? 'delta-up' : 'delta-down')]">
                          {{ deltaInfo(score).text }}
                        </span>
                        <span v-else class="score-delta delta-flat">—</span>
                      </td>
                    </template>
                    <td v-else class="zl-body-table-td-right zl-body-table-td-bottom zl-body-table-td-score">
                      <div class="score-cell">
                        <span class="score-value">{{ formatScore(score.rank) }}</span>
                        <span v-if="deltaInfo(score)"
                              :class="['score-delta', deltaInfo(score).flat ? 'delta-flat' : (deltaInfo(score).up ? 'delta-up' : 'delta-down')]">
                          {{ deltaInfo(score).text }}
                        </span>
                      </div>
                    </td>
                    <td class="zl-body-table-detail zl-body-table-td-bottom">
                      <van-icon @click="queryRealRankList(score)" name="chart-trending-o"
                                size="18px"></van-icon>
                    </td>
                  </tr>
                </template>
              </table>
              <van-empty v-show="showEmpty" description="该英雄数据还未同步...">
                <van-button round type="danger" size="small" class="empty-action-btn" @click="showHeroList">换个英雄查询</van-button>
              </van-empty>
            </div>
          </van-tab>
        </van-tabs>
        <van-popup
                v-model="heroListPanel"
                closeable
                round
                position="bottom"
                :style="{ height: '60%',maxHeight: '60%'}">
          <div class="hero-select-container">
            <div class="hero-list-panel-title">
              <span>请选择查询的英雄</span>
              <van-icon @click="queryScoreNotice" name="question-o"></van-icon>
            </div>
            <van-search v-model="searchKeyword" shape="round" placeholder="搜索英雄名称" class="hero-search"></van-search>
            <!-- 最近查询 -->
            <div class="recent-heroes" v-if="!trimmedKeyword && recentHeroes.length">
              <span class="recent-label">最近</span>
              <div class="recent-list">
                <div class="recent-item" v-for="hero in recentHeroes" :key="'recent' + hero.ename" @click="queryScore(hero)">
                  <img :src="`https://game.gtimg.cn/images/yxzj/img201606/heroimg/${hero.ename}/${hero.ename}.jpg`" alt=""/>
                  <span>{{ hero.cname }}</span>
                </div>
              </div>
            </div>
            <!-- 搜索结果 -->
            <div class="hero-search-result" v-if="trimmedKeyword">
              <div class="search-result-summary">共找到 <span class="search-result-count">{{ searchedHeroes.length }}</span> 个英雄</div>
              <van-tabs v-if="searchedHeroes.length" v-model="searchTypeActive" sticky>
                <van-tab v-for="tabItem in searchTypeTabs"
                         :title="`${tabItem.text}(${tabItem.count})`"
                         :name="tabItem.value"
                         :key="'st' + tabItem.value">
                  <div class="hero-list-content">
                    <van-grid :border="false" :column-num="5" icon-size="3rem">
                      <van-grid-item @click="queryScore(hero)" v-for="hero in searchHeroesByType(tabItem.value)"
                                   :class="['hero-grid-item', isLongName(hero.cname) ? 'hero-long-name' : '']"
                                   :text="hero.cname"
                                   :badge="isNew(hero) ? '新' : ''"
                                   :icon="`https://game.gtimg.cn/images/yxzj/img201606/heroimg/${hero.ename}/${hero.ename}-smallskin-1.jpg`"
                                   :key="hero.id">
                      </van-grid-item>
                    </van-grid>
                  </div>
                </van-tab>
              </van-tabs>
              <van-empty v-if="!searchedHeroes.length" description="未找到相关英雄" image-size="80"></van-empty>
            </div>
            <!-- 职业分类 -->
            <div class="hero-tabs-container" v-else>
              <van-tabs v-model="heroTypeActive" @click="filterHeroes" sticky>
                <van-tab v-for="heroTypeItem in heroTypes" :title="heroTypeItem.text"
                       :key="heroTypeItem.value">
                  <div class="hero-list-content">
                    <van-grid :border="false" :column-num="5" icon-size="3rem">
                      <van-grid-item @click="queryScore(hero)" v-for="hero in filterHeroList"
                                   :class="['hero-grid-item', isLongName(hero.cname) ? 'hero-long-name' : '']"
                                   :text="hero.cname"
                                   :badge="isNew(hero) ? '新' : ''"
                                   :icon="`https://game.gtimg.cn/images/yxzj/img201606/heroimg/${hero.ename}/${hero.ename}-smallskin-1.jpg`"
                                   :key="hero.id">
                      </van-grid-item>
                    </van-grid>
                  </div>
                </van-tab>
              </van-tabs>
            </div>
          </div>
        </van-popup>
      </div>
      <!--中间部分结束-->
      
      <van-dialog style="background-color: transparent" v-model="showWarOrderNotice" :show-confirm-button="false" :close-on-click-overlay="true">
        <van-image
                width="100%"
                fit="contain"
                :show-loading="false"
                src="//p1.meituan.net/csc/d495f5d11f1e26fc4a15da515a191e6b79420.png"
        />
        <van-button @click="redirectWarOrder"
                    style="position: absolute; left: 3.5rem; bottom: 0.7rem; width: 13rem; background-color: transparent; border: none;"
                    type="primary"></van-button>
        <van-icon @click="closeWarOrderNotice" color="white" size="1.8rem"
                  style="position: absolute; top: 0; right: 0;" name="close"></van-icon>
      </van-dialog>
    </div>
    
    <!-- 底部改战区引流栏 -->
    <div class="warzone-cta" @click="showWarOrderDialog">
      <div class="cta-left">
        <span class="cta-title">想换个低分战区？</span>
        <span class="cta-sub">支持全区服修改，低分战区随心选</span>
      </div>
      <span class="cta-btn">一键改战区</span>
    </div>
    
    
    <!-- 趋势图弹窗 -->
    <van-popup
      v-model="showTrendChart"
      closeable
      close-icon="cross"
      round
      position="bottom"
      :style="{ height: '72%',maxHeight: '72%'}"
      @closed="handleChartClosed"
      class="trend-chart-popup">
      <div class="trend-chart-container">
        <div class="trend-drag-bar"></div>
        <div class="trend-head">
          <div class="trend-chart-title">{{ trendTitle }}</div>
          <div class="trend-chart-subtitle">最低上榜战力趋势</div>
        </div>
        <div class="trend-range-bar">
          <span v-for="range in trendRanges" :key="range"
                :class="['range-seg', trendRange === range ? 'range-seg-active' : '']"
                @click="changeTrendRange(range)">{{ range }}天</span>
        </div>
        <div class="trend-stats" v-if="trendStats">
          <div class="trend-stat-item">
            <div class="trend-stat-label">当前</div>
            <div class="trend-stat-value">{{ formatScore(trendStats.current) }}</div>
          </div>
          <div class="trend-stat-item trend-stat-mid">
            <div class="trend-stat-label">近{{ trendRange }}天</div>
            <div :class="['trend-stat-value', trendStats.diff > 0 ? 'stat-up' : (trendStats.diff < 0 ? 'stat-down' : 'stat-flat')]">
              {{ trendStats.diff > 0 ? '↑ ' : (trendStats.diff < 0 ? '↓ ' : '') }}{{ trendStats.diff === 0 ? '持平' : formatScore(trendStats.absDiff) }}
            </div>
          </div>
          <div class="trend-stat-item">
            <div class="trend-stat-label">最低</div>
            <div class="trend-stat-value">{{ formatScore(trendStats.min) }}</div>
          </div>
        </div>
        <div ref="trendChart" class="trend-chart">
          <div v-if="chartLoading" class="chart-loading">
            <van-loading type="spinner" color="#ee0a24" />
            <div class="loading-text">图表加载中...</div>
          </div>
          <van-empty 
            v-if="!chartLoading && (!trendData.dates || trendData.dates.length === 0)" 
            description="暂无战力趋势数据" 
            class="trend-empty"
          ></van-empty>
        </div>
        <div class="trend-insight" v-if="trendInsight">
          <van-icon name="info-o"></van-icon>
          <span>近{{ trendRange }}天{{ trendInsight.direction }} <span :class="trendInsight.up ? 'stat-up' : 'stat-down'">{{ trendInsight.pct }}%</span>，{{ trendInsight.hint }}</span>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { signRequest } from '../utils/signature';
import * as echarts from 'echarts/core';
import { LineChart } from 'echarts/charts';
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  MarkPointComponent,
  MarkLineComponent
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import { Loading } from 'vant';

// 注册必需的组件
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  MarkPointComponent,
  MarkLineComponent,
  LineChart,
  CanvasRenderer
]);

const RECENT_HEROES_KEY = 'zl_recent_heroes';
const MEDAL_ICONS = [
  require('../assets/zl/ranks/rank-1.png'),
  require('../assets/zl/ranks/rank-2.png'),
  require('../assets/zl/ranks/rank-3.png')
];
const LEVEL_NAME_MAP = {
  province: '金牌榜',
  city: '银牌榜',
  district: '铜牌榜'
};

export default {
  name: 'GameZL',
  components: {
    [Loading.name]: Loading
  },
  data() {
    return {
      showWarOrderNotice: false,
      levelActive: 0,
      lastLevel: 0, // 最近一次选中的榜级(0-2), 用于系统tab面板沿用列布局
      heroTypeActive: 0,
      gameAreaId: 1,
      heroListPanel: false,
      heroes: [],
      synDate:'-',
      filterHeroList: [],
      searchKeyword: '',
      searchTypeActive: 'all',
      recentHeroes: [],
      historyMap: {},
      currentHero: {
        cname: '武则天',
        ename: 136,
        createTime: "2023-04-17T02:06:28.000+0000"
      },
      showTrendChart: false,
      trendData: {
        dates: [],
        values: []
      },
      trendRanges: [7, 30, 90],
      trendRange: 30,
      currentTrendScore: null,
      chartInstance: null,
      chartResizeHandler: null,
      gameAreaOptions: [
        {text: '苹果微信区', value: 3},
        {text: '安卓微信区', value: 1},
        {text: '苹果QQ区', value: 2},
        {text: '安卓QQ区', value: 0}
      ],
      cityLevels: [
        {text: '金牌榜', value: 'province'},
        {text: '银牌榜', value: 'city'},
        {text: '铜牌榜', value: 'district'},
        {text: '选择系统', value: 'selectArea'}
      ],
      heroTypes: [
        {text: '坦克', value: 3},
        {text: '战士', value: 1},
        {text: '刺客', value: 4},
        {text: '法师', value: 2},
        {text: '射手', value: 5},
        {text: '辅助', value: 6},
      ],
      scores: [],
      filterScores: [],
      showEmpty: false,
      loading: true,
      chartLoading: true,
      // 滚动相关状态
      isSticky: false,
      scrollProgress: 0,
      stickyHeaderHeight: 60, // 吸顶区域高度
      heroImageSize: '4.5rem', // 初始头像大小
      heroNameFontSize: '1rem', // 初始名字大小
      medalIcons: MEDAL_ICONS, // 前三名奖章切图
    }
  },
  computed: {
    // 计算吸顶区域英雄头像的样式
    stickyHeroStyle() {
      return {
        transform: this.isSticky ? `translateX(${this.scrollProgress * -15}px)` : 'translateX(0)',
        opacity: 1
      };
    },
    // 计算英雄名字的样式
    heroNameStyle() {
      return {
        fontSize: this.isSticky ? `${Math.max(0.8, 1 - this.scrollProgress * 0.3)}rem` : '1rem',
        opacity: this.isSticky ? (1 - this.scrollProgress * 0.5) : 1,
        maxWidth: this.isSticky ? '100px' : 'auto'
      };
    },
    // 计算同步时间区域的样式
    syncTimeStyle() {
      return {
        transform: this.isSticky ? `translateX(${this.scrollProgress * 10}px)` : 'translateX(0)',
        opacity: this.scrollProgress
      };
    },
    // 当前系统区名称
    currentSystemName() {
      const option = this.gameAreaOptions.find(item => item.value === this.gameAreaId);
      return option ? option.text : '选择系统';
    },
    // 当前榜单榜首战力
    topScore() {
      return this.filterScores.length ? this.filterScores[0].rank : 0;
    },
    // 当前榜单最低上榜战力
    minScore() {
      return this.filterScores.length ? this.filterScores[this.filterScores.length - 1].rank : 0;
    },
    trimmedKeyword() {
      return this.searchKeyword.trim();
    },
    // 英雄搜索结果（跨职业）
    searchedHeroes() {
      const keyword = this.trimmedKeyword;
      if (!keyword) {
        return [];
      }
      return this.heroes.filter(hero => hero.cname && hero.cname.indexOf(keyword) !== -1);
    },
    // 搜索结果按职业细分的 tab（只展示有结果的职业）
    searchTypeTabs() {
      const tabs = [{text: '全部', value: 'all', count: this.searchedHeroes.length}];
      this.heroTypes.forEach(type => {
        const count = this.searchedHeroes.filter(hero => hero.heroType === type.value).length;
        if (count > 0) {
          tabs.push({text: type.text, value: type.value, count});
        }
      });
      return tabs;
    },
    // 趋势弹窗标题：英雄 · 地区 · 榜级
    trendTitle() {
      if (!this.currentTrendScore) {
        return `${this.currentHero.cname} 战力趋势`;
      }
      const levelName = LEVEL_NAME_MAP[this.currentTrendScore.level] || '';
      return `${this.currentHero.cname} · ${this.currentTrendScore.address} · ${levelName}`;
    },
    // 趋势统计：当前 / 区间涨跌 / 最低
    trendStats() {
      const values = this.trendData.values;
      if (!values || values.length === 0) {
        return null;
      }
      const current = values[values.length - 1];
      const diff = current - values[0];
      return {
        current,
        diff,
        absDiff: diff > 0 ? diff : -diff,
        min: Math.min.apply(null, values)
      };
    },
    // 趋势结论：涨跌幅与门槛提示
    trendInsight() {
      const stats = this.trendStats;
      if (!stats || stats.diff === 0 || !this.trendData.values[0]) {
        return null;
      }
      const up = stats.diff > 0;
      return {
        up,
        pct: (stats.absDiff / this.trendData.values[0] * 100).toFixed(1),
        direction: up ? '上涨' : '下降',
        hint: up ? '上榜门槛正在提高' : '上榜门槛正在降低'
      };
    }
  },
  methods: {
    onClickLeft() {
      if (window && window.history) {
        window.history.back()
      } else {
        this.$router.back()
      }
    },
    showHeroList() {
      this.heroListPanel = true;
      this.heroTypeActive = 0;
      this.searchKeyword = '';
      this.filterHeroes();
    },
    initHeroes() {
      this.$request.get('/api/app/pvp/heroes').then((response) => {
        if ('0000' === response.data.code) {
          this.heroes = response.data.data;
          this.filterHeroes();
        }
      });
    },
    filterHeroes() {
      this.filterHeroList = this.heroes.filter(hero => hero.heroType === this.heroTypes[this.heroTypeActive].value);
    },
    // 面板是否拆分"战力/变动"两列: 金/银牌榜拆分; 系统tab面板沿用最近榜级的布局
    splitCols(tabIndex) {
      const level = tabIndex === 3 ? this.lastLevel : tabIndex;
      return level <= 1;
    },
    // 搜索结果按职业过滤
    searchHeroesByType(type) {
      if (type === 'all') {
        return this.searchedHeroes;
      }
      return this.searchedHeroes.filter(hero => hero.heroType === type);
    },
    isNew(hero) {
      const createTime = new Date(hero.createTime);
      const currentDate = new Date();
      const timeDifference = currentDate.getTime() - createTime.getTime();
      const daysDifference = timeDifference / (1000 * 3600 * 24);
      return daysDifference <= 30;
    },
    isLongName(name) {
      return name && name.length > 4;
    },
    formatScore(value) {
      const num = parseInt(value, 10);
      if (isNaN(num)) {
        return value;
      }
      return num.toLocaleString('en-US');
    },
    formatDay(time) {
      const date = new Date(time);
      if (isNaN(date.getTime())) {
        return '';
      }
      const month = `${date.getMonth() + 1}`.padStart(2, '0');
      const day = `${date.getDate()}`.padStart(2, '0');
      return `${date.getFullYear()}-${month}-${day}`;
    },
    // 最近查询英雄
    loadRecentHeroes() {
      try {
        const stored = JSON.parse(localStorage.getItem(RECENT_HEROES_KEY) || '[]');
        this.recentHeroes = Array.isArray(stored) ? stored.slice(0, 5) : [];
      } catch (e) {
        this.recentHeroes = [];
      }
    },
    saveRecentHero(hero) {
      const item = {
        cname: hero.cname,
        ename: hero.ename,
        heroType: hero.heroType,
        createTime: hero.createTime
      };
      const list = [item, ...this.recentHeroes.filter(h => h.ename !== hero.ename)].slice(0, 5);
      this.recentHeroes = list;
      try {
        localStorage.setItem(RECENT_HEROES_KEY, JSON.stringify(list));
      } catch (e) {
        // 存储不可用时静默降级
      }
    },
    queryScore(hero) {
      this.filterScores = [];
      this.historyMap = {};
      this.loading = true;
      this.showEmpty = false;
      this.levelActive = 0;
      this.lastLevel = 0;
      this.heroListPanel = false;
      
      if (hero) {
        this.currentHero = hero;
        this.saveRecentHero(hero);
      }
      
      // 构造请求参数
      const params = {
        heroId: this.currentHero.ename,
        gameAreaId: this.gameAreaId
      };
      
      // 添加签名
      const signedParams = signRequest(params);
      
      this.$request.get('/api/app/pvp/v2/area/score', {
        params: signedParams
      }).then((response) => {
        if ('0000' === response.data.code) {
          this.scores = response.data.data.heroList;
          // 对scores排序 - 按战力值从高到低
          this.sortScores();
          this.filterScores = this.scores.filter(score => score.level === this.cityLevels[this.levelActive].value);
          this.loading = false;
          this.synDate = response.data.data.synDate;
          if (this.filterScores.length === 0) {
            this.showEmpty = true
          }
          // 拉取历史数据计算涨跌
          this.queryScoreHistory();
        } else {
          this.$toast(response.data.message || '查询失败');
          this.loading = false;
        }
      }).catch(error => {
        console.error('查询战力失败:', error);
        this.$toast('网络异常，请稍后重试');
        this.loading = false;
      });
    },
    // 查询历史战力，构建昨日对比数据
    queryScoreHistory() {
      const signedParams = signRequest({
        heroId: this.currentHero.ename,
        gameAreaId: this.gameAreaId
      });
      this.$request.get('/api/app/pvp/v2/area/score/history', {
        params: signedParams
      }).then((response) => {
        if ('0000' === response.data.code && response.data.data && response.data.data.historyList) {
          this.buildHistoryMap(response.data.data.historyList);
        }
      }).catch(() => {
        // 历史数据仅用于涨跌展示，失败不打扰用户
      });
    },
    buildHistoryMap(historyList) {
      const map = {};
      const synDay = this.synDate;
      historyList.forEach(record => {
        const day = this.formatDay(record.rankTime);
        // 只取同步日之前的最近一条记录
        if (!day || (synDay && day >= synDay)) {
          return;
        }
        // adcode 是每次同步新生成的 ID，跨天不稳定，用 level+address 做对比 key
        const key = `${record.level}|${record.address}`;
        if (!map[key] || day > map[key].date) {
          map[key] = { rank: parseInt(record.rank, 10), date: day };
        }
      });
      this.historyMap = map;
    },
    // 计算某行的涨跌信息
    deltaInfo(score) {
      const entry = this.historyMap[`${score.level}|${score.address}`];
      if (!entry || isNaN(entry.rank)) {
        return null;
      }
      const diff = parseInt(score.rank, 10) - entry.rank;
      if (diff === 0) {
        return { flat: true, text: '持平' };
      }
      const abs = diff > 0 ? diff : -diff;
      return {
        up: diff > 0,
        text: `${diff > 0 ? '▲' : '▼'}${this.formatScore(abs)}`
      };
    },
    // 排序方法 - 按照战力值从高到低排序
    sortScores() {
      this.scores.sort((a, b) => {
        return parseInt(b.rank) - parseInt(a.rank);
      });
    },
    changeGameArea(value) {
      window.setTimeout(() => {
        this.levelActive = 0;
        this.queryScore();
      }, 100)
    },
    closeDropdown() {
      window.setTimeout(() => {
        this.levelActive = 0;
        this.changeLevel();
      }, 100)
    },
    changeLevel() {
      if (this.levelActive <= 2 && !this.loading) {
        this.lastLevel = this.levelActive;
        this.filterScores = this.scores.filter(score => score.level === this.cityLevels[this.levelActive].value);
        // 确保切换等级时也按排序显示
        this.filterScores.sort((a, b) => parseInt(b.rank) - parseInt(a.rank));
        this.showEmpty = this.filterScores.length === 0;
      }
    },
    queryScoreNotice() {
      this.$dialog.alert({
        title: '查询限额说明',
        confirmButtonText: '我知道了',
        message: '普通用户每天可免费查询1次,VIP用户每天可查询6次,每日0点自动重置次数',
        theme: 'round-button',
      });
    },
    showWarOrderDialog() {
      this.showWarOrderNotice = true;
    },
    closeWarOrderNotice() {
      this.showWarOrderNotice = false;
    },
    redirectWarOrder() {
      this.closeWarOrderNotice();
      this.$router.push('/warzone');
    },
    queryRealRankList(score) {
      this.currentTrendScore = score;
      this.trendRange = 30;
      this.fetchTrend();
    },
    // 切换趋势时间范围
    changeTrendRange(range) {
      if (range === this.trendRange || this.chartLoading) {
        return;
      }
      this.trendRange = range;
      this.fetchTrend();
    },
    // 查询并展示趋势数据
    fetchTrend() {
      const score = this.currentTrendScore;
      if (!score) {
        return;
      }
      
      // 显示加载状态
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      
      // 初始化图表加载状态
      this.chartLoading = true;
      
      // 构造请求参数（startDate 不参与签名，后端仅校验以下四项）
      const params = {
        heroId: this.currentHero.ename,
        gameAreaId: this.gameAreaId,
        adcode: score.address,
        level: score.level
      };
      
      // 添加签名
      const signedParams = signRequest(params);
      signedParams.startDate = this.formatDay(Date.now() - this.trendRange * 24 * 3600 * 1000);
      
      // 调用后端接口获取趋势数据
      this.$request.get('/api/app/pvp/v2/area/score/trend', {
        params: signedParams
      }).then((response) => {
        this.$toast.clear();
        if ('0000' === response.data.code) {
          // 更新趋势数据
          const result = response.data.data;
          
          // 检查是否有必要的趋势数据
          if (!result || !result.dateList || result.dateList.length === 0 || !result.scoreList || result.scoreList.length === 0) {
            this.trendData = {
              dates: [],
              values: []
            };
            this.showTrendChart = true;
            this.chartLoading = false;
            return;
          }
          
          // 将后端返回的数据结构映射到前端使用的数据结构
          this.trendData = {
            dates: result.dateList || [],
            values: result.scoreList || []
          };
          
          // 显示趋势图表弹窗
          this.showTrendChart = true;
          
          // 渲染趋势图表（在弹窗显示后执行）
          this.$nextTick(() => {
            this.renderTrendChart();
          });
        } else {
          // 设置空数据
          this.trendData = {
            dates: [],
            values: []
          };
          this.showTrendChart = true;
          this.chartLoading = false;
          
          this.$toast(response.data.message || '查询失败');
        }
      }).catch(error => {
        this.$toast.clear();
        console.error('查询趋势数据失败:', error);
        
        // 设置空数据
        this.trendData = {
          dates: [],
          values: []
        };
        this.showTrendChart = true;
        this.chartLoading = false;
        
        this.$toast('网络异常，请稍后重试');
      });
    },
    showSynNotice() {
      this.$dialog.alert({
        title: '战力同步说明',
        message: '由于分数是实时变动的, 查询结果可能有些许的误差, 我们每日会不定时的更新数据, 来帮助您查询最接近的分数',
        theme: 'round-button',
        confirmButtonText: '我知道了',
        className:'queryWarnDialog'
      });
    },
    // 渲染趋势图表
    renderTrendChart() {
      // 完成加载状态
      this.chartLoading = false;
      
      if (!this.trendData || !this.trendData.dates || !this.trendData.values) {
        console.error('趋势数据不完整');
        return;
      }
      
      if (this.trendData.dates.length === 0 || this.trendData.values.length === 0) {
        return;
      }
      
      // 确保DOM元素存在并可见
      if (!this.$refs.trendChart) {
        setTimeout(() => {
          this.renderTrendChart();
        }, 300);
        return;
      }
      
      try {
        // 初始化图表 - 使用直接DOM选择作为备选方案
        const chartDom = this.$refs.trendChart;
        
        // 等待DOM完全渲染
        setTimeout(() => {
          // 如果已有实例，先销毁
          if (this.chartInstance) {
            this.chartInstance.dispose();
            this.chartInstance = null;
          }
          
          // 检查趋势数据是否为空（二次检查，防止异步问题导致数据变化）
          if (!this.trendData || !this.trendData.dates || this.trendData.dates.length === 0 || 
              !this.trendData.values || this.trendData.values.length === 0) {
            return;
          }
          
          // 使用try-catch处理图表初始化过程
          try {
            const myChart = echarts.init(chartDom);
            
            // 格式化 MM/DD
            const toMD = (value) => {
              const date = new Date(value);
              if (isNaN(date.getTime())) {
                return value;
              }
              const m = `${date.getMonth() + 1}`.padStart(2, '0');
              const d = `${date.getDate()}`.padStart(2, '0');
              return `${m}/${d}`;
            };
            const dates = this.trendData.dates;
            const values = this.trendData.values;
            const lastIdx = values.length - 1;
            let minIdx = 0;
            values.forEach((v, i) => { if (v < values[minIdx]) minIdx = i; });
            const fmt = (v) => Number(v).toLocaleString('en-US');
            
            // 标记点：最新值(红色标签) + 最低值(下方红字)，参考设计稿
            const markPointData = [{
              coord: [lastIdx, values[lastIdx]],
              symbol: 'circle',
              symbolSize: 9,
              itemStyle: { color: '#fff', borderColor: '#ee0a24', borderWidth: 2 },
              label: {
                show: true,
                position: 'top',
                distance: 10,
                offset: [-36, 0],
                formatter: `${toMD(dates[lastIdx])}  ${fmt(values[lastIdx])}`,
                color: '#fff',
                fontSize: 11,
                fontWeight: 'bold',
                backgroundColor: '#ee0a24',
                padding: [4, 8],
                borderRadius: 4
              }
            }];
            if (minIdx !== lastIdx) {
              markPointData.push({
                coord: [minIdx, values[minIdx]],
                symbol: 'circle',
                symbolSize: 7,
                itemStyle: { color: '#ee0a24' },
                label: {
                  show: true,
                  position: minIdx > values.length * 0.7 ? 'left' : 'right',
                  distance: 8,
                  formatter: `${toMD(dates[minIdx])}\n${fmt(values[minIdx])}`,
                  color: '#ee0a24',
                  fontSize: 10,
                  fontWeight: 'bold',
                  lineHeight: 14,
                  align: 'center'
                }
              });
            }
            
            // 构建图表配置（贴合设计稿：红色主线、浅红渐变、虚线网格）
            const option = {
              tooltip: {
                trigger: 'axis',
                backgroundColor: 'rgba(50, 50, 50, 0.9)',
                borderWidth: 0,
                textStyle: { color: '#fff', fontSize: 12 },
                formatter: (params) => {
                  const p = params[0];
                  return `${toMD(p.name)}<br/>战力: ${fmt(p.value)}`;
                }
              },
              xAxis: {
                type: 'category',
                data: dates,
                boundaryGap: false,
                axisTick: { show: false },
                axisLine: { lineStyle: { color: '#ebedf0' } },
                axisLabel: {
                  color: '#969799',
                  fontSize: 10,
                  interval: Math.max(0, Math.ceil(dates.length / 6) - 1),
                  formatter: toMD
                }
              },
              yAxis: {
                type: 'value',
                scale: true,
                axisLine: { show: false },
                axisTick: { show: false },
                splitLine: { lineStyle: { type: 'dashed', color: '#ebedf0' } },
                axisLabel: {
                  color: '#969799',
                  fontSize: 10,
                  formatter: fmt
                }
              },
              series: [
                {
                  name: '战力',
                  type: 'line',
                  data: values,
                  smooth: 0.4,
                  symbol: 'none',
                  lineStyle: {
                    width: 2.5,
                    color: '#ee0a24'
                  },
                  markPoint: {
                    data: markPointData
                  },
                  markLine: {
                    silent: true,
                    symbol: 'none',
                    label: { show: false },
                    lineStyle: { type: 'dashed', color: '#ee0a24', opacity: 0.5 },
                    data: [[
                      { coord: [lastIdx, values[lastIdx]] },
                      { coord: [lastIdx, 'min'] }
                    ]]
                  },
                  areaStyle: {
                    color: {
                      type: 'linear',
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [
                        { offset: 0, color: 'rgba(238, 10, 36, 0.22)' },
                        { offset: 1, color: 'rgba(238, 10, 36, 0.02)' }
                      ]
                    }
                  }
                }
              ],
              grid: {
                left: '3%',
                right: '3%',
                bottom: '6%',
                top: '18%',
                containLabel: true
              }
            };
            
            // 渲染图表
            myChart.setOption(option);
            
            // 保存图表实例以便后续可能的操作
            this.chartInstance = myChart;
          } catch (innerError) {
            console.error('图表初始化失败:', innerError);
          }
        }, 500);
      } catch (error) {
        console.error('渲染趋势图表失败:', error);
        this.$toast('图表渲染失败，请重试');
      }
    },
    handleChartClosed() {
      // 关闭弹窗时销毁图表
      if (this.chartInstance) {
        this.chartInstance.dispose();
        this.chartInstance = null;
      }
    },
    // 处理页面滚动
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      // 是否处于吸顶状态
      this.isSticky = scrollTop > 200;
      
      // 计算滚动进度，用于动画过渡
      if (scrollTop <= 200) {
        this.scrollProgress = 0;
      } else if (scrollTop >= 272) {
        this.scrollProgress = 1;
      } else {
        this.scrollProgress = (scrollTop - 200) / (272 - 200);
      }
      
      // 随着滚动动态调整头像大小，最小不低于2.2rem
      this.heroImageSize = this.isSticky 
        ? `${Math.max(2.2, 4.5 - this.scrollProgress * 2.3)}rem` 
        : '4.5rem';
    },
  },
  watch: {
    trimmedKeyword() {
      // 关键词变化时回到"全部"tab
      this.searchTypeActive = 'all';
    },
    showTrendChart(val) {
      // 弹窗关闭时销毁图表实例
      if (!val && this.chartInstance) {
        this.chartInstance.dispose();
        this.chartInstance = null;
      }
    }
  },
  mounted() {
    this.loadRecentHeroes();
    this.queryScore();
    this.initHeroes();
    
    // 添加滚动事件监听
    window.addEventListener('scroll', this.handleScroll);
    
    // 窗口尺寸变化时自动调整图表大小（只注册一次，销毁时移除）
    this.chartResizeHandler = () => {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    };
    window.addEventListener('resize', this.chartResizeHandler);
  },
  beforeDestroy() {
    // 清除事件监听（Vue 2 钩子为 beforeDestroy）
    window.removeEventListener('scroll', this.handleScroll);
    if (this.chartResizeHandler) {
      window.removeEventListener('resize', this.chartResizeHandler);
      this.chartResizeHandler = null;
    }
    if (this.chartInstance) {
      this.chartInstance.dispose();
      this.chartInstance = null;
    }
  }
}
</script>

<style scoped>
.game-zl-container {
  padding-bottom: calc(64px + constant(safe-area-inset-bottom));
  padding-bottom: calc(64px + env(safe-area-inset-bottom));
}

.zl-header {
  height: 17rem;
  position: relative;
  /* flow-root: 无导航栏时 .hero-select-div 的 margin-top 不能穿透到父级(否则头部上方留白) */
  display: flow-root;
  background-size: cover !important;
  background-position: center top !important;
}

.transparent-nav {
  background-color: transparent;
}

/* 修改去除导航栏边框的样式 */
.transparent-nav :deep(.van-hairline--bottom::after) {
  border: none !important;
}

.transparent-nav :deep([class*=van-hairline]::after) {
  border: none !important;
}

.transparent-nav :deep(.van-nav-bar__content) {
  border-bottom: none !important;
}

.transparent-nav :deep(.van-nav-bar__text), 
.transparent-nav :deep(.van-nav-bar__title), 
.transparent-nav :deep(.van-icon) {
  color: white !important;
  font-weight: bold;
}

.hero-select-div {
  width: 100%;
  margin: 3vh auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.hero-name {
  margin-top: 8px;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hero-name .van-icon {
  margin-left: 5px;
}

/* 头部战力摘要 */
.zl-header-stats {
  position: absolute;
  bottom: 44px;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  color: white;
}

.stat-block {
  text-align: center;
}

.stat-value {
  font-size: 1.15rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
}

.stat-label {
  font-size: 0.7rem;
  opacity: 0.85;
  margin-top: 2px;
}

.stat-divider {
  width: 1px;
  height: 24px;
  background: rgba(255, 255, 255, 0.35);
}

/* 去掉下拉菜单的阴影，覆盖背景 */
:deep(.van-dropdown-menu__bar) {
  background-color: transparent !important;
  box-shadow: none !important;
}

/* 系统区下拉：列表 icon 常显，展开时翻转 */
:deep(.van-dropdown-menu__title) {
  margin-right: 10px;
  padding-right: 4px;
}

:deep(.van-dropdown-menu__title)::after {
  display: none;
}

.area-title {
  display: inline-flex;
  align-items: center;
}

.area-title-icon {
  margin-left: 4px;
  font-size: 17px;
  color: #323233;
  transition: transform 0.2s ease, color 0.2s ease;
}

:deep(.van-dropdown-menu__title--active) .area-title-icon {
  transform: rotate(180deg);
  color: #ee0a24;
}

.sync-time {
  font-weight: bold;
}

.zl-body {
  background-color: white;
}
.zl-body-table {
  padding: 2px 0 15px 0;
}

.zl-body-table-detail {
  width: 30px;
  text-align: center;
  font-size: 13px;
  color: rgb(249 148 86);
  font-weight: 600;
}

.zl-body-table-detail i {
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
}

/* 表格列头 */
.zl-table-head th {
  padding: 8px;
  font-size: 12px;
  font-weight: 500;
  color: #969799;
  text-align: center;
  background-color: #fafafa;
}

tr td {
  padding: 10px 8px;
  color: rgb(51, 51, 51);
  font-size: 14px;
  border-right-color: rgb(238, 238, 238);
  border-left-color: rgb(238, 238, 238);
  border-bottom-color: rgb(238, 238, 238);
  text-align: center;
  font-family: -apple-system-font, Helvetica Neue, Helvetica, sans-serif;
}

.zl-body-table-td-left {
  border-left-width: 1px;
  border-left-style: solid
}

.zl-body-table-td-right {
  border-right-width: 1px;
  border-right-style: solid
}

.zl-body-table-td-bottom {
  border-bottom-width: 1px;
  border-bottom-style: solid
}

.zl-body-table-td-score {
  width: 68px;
  padding-left: 4px;
  padding-right: 4px;
}

/* 金/银牌榜拆分出的变动列 */
.zl-body-table-td-delta {
  width: 52px;
  padding-left: 4px;
  padding-right: 4px;
}

.zl-body-table-td-delta .score-delta {
  font-size: 0.75rem;
}

/* 排名与奖牌 */
.rank-cell {
  width: 40px;
}

.rank-num {
  color: #999;
  font-weight: 600;
}

.rank-medal-img {
  width: 26px;
  height: 26px;
  vertical-align: middle;
  display: inline-block;
}

/* 战力值与涨跌 */
.score-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.2;
}

.score-value {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.score-delta {
  font-size: 0.68rem;
  margin-top: 1px;
  font-variant-numeric: tabular-nums;
}

.delta-up {
  color: #ee0a24;
}

.delta-down {
  color: #07c160;
}

.delta-flat {
  color: #c8c9cc;
}

/* 表格骨架屏 */
.skeleton-row td {
  padding: 12px 8px;
}

.sk {
  display: inline-block;
  background: linear-gradient(90deg, #f0f0f0 25%, #e6e6e6 37%, #f0f0f0 63%);
  background-size: 400% 100%;
  animation: sk-shimmer 1.4s ease infinite;
  border-radius: 4px;
  height: 14px;
  vertical-align: middle;
}

.sk-circle {
  width: 22px;
  height: 22px;
  border-radius: 50%;
}

.sk-bar {
  min-width: 24px;
}

@keyframes sk-shimmer {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}

/* 空状态操作按钮 */
.empty-action-btn {
  min-width: 120px;
}

.hero-select-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.hero-list-panel-title {
  font-size: 16px;
  line-height: 16px;
  font-weight: 600;
  padding: 16px 16px 8px;
  position: relative;
  box-sizing: border-box;
  text-align: center;
  background-color: white;
  z-index: 10;
  position: sticky;
  top: 0;
}

.hero-search {
  padding: 4px 12px;
}

/* 最近查询 */
.recent-heroes {
  display: flex;
  align-items: center;
  padding: 4px 12px 8px;
  gap: 8px;
}

.recent-label {
  font-size: 0.75rem;
  color: #969799;
  flex-shrink: 0;
}

.recent-list {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  /* 隐藏横向滚动条 */
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.recent-list::-webkit-scrollbar {
  display: none;
}

.recent-item {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 10px 3px 4px;
  border-radius: 16px;
  background: #f7f8fa;
  flex-shrink: 0;
  cursor: pointer;
}

.recent-item img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
}

.recent-item span {
  font-size: 0.8rem;
  color: #323233;
  white-space: nowrap;
}

/* 搜索结果区域 */
.hero-search-result {
  flex: 1;
  overflow: auto;
}

.search-result-summary {
  padding: 2px 16px 8px;
  font-size: 0.78rem;
  color: #969799;
}

.search-result-count {
  color: #ee0a24;
  font-weight: 600;
  margin: 0 2px;
}

.hero-tabs-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.hero-tabs-container :deep(.van-tabs) {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
}

.hero-tabs-container :deep(.van-tabs__wrap) {
  position: sticky;
  z-index: 99;
}

.hero-tabs-container :deep(.van-tabs__content) {
  flex: 1;
  overflow: auto;
}

.hero-list-content {
  padding-bottom: 20px;
}

.van-icon__image {
  border-radius: 10px;
}

.zl-query-time {
  position: relative;
  padding-left: 10px;
  margin: 0;
}

.secondaryQuestionBtn {
  margin-left: 5px;
  border-radius: 10px;
  font-weight: bold;
  cursor: pointer;
}

.zl-query-time:after {
  content: "";
  position: absolute;
  width: 8px;
  height: 100%;
  background: red;
  border-radius: 2px;
  left: 0;
  top: 0;
  margin-right: 10px;
}

/* 为英雄头像添加圆角 */
.hero-grid-item :deep(.van-grid-item__icon) {
  border-radius: 12px;
  overflow: hidden;
}

.hero-grid-item :deep(.van-image) {
  border-radius: 12px;
  overflow: hidden;
}

.hero-grid-item :deep(.van-icon__image) {
  border-radius: 12px !important;
}

/* 统一所有弹窗中的图片圆角 */
.van-popup :deep(.van-icon__image) {
  border-radius: 12px !important;
}

.van-popup :deep(.van-image__img) {
  border-radius: 12px !important;
}

/* 适配不同设备显示 */
@media screen and (max-width: 375px) {
  .hero-grid-item :deep(.van-grid-item__icon),
  .hero-grid-item :deep(.van-image),
  .hero-grid-item :deep(.van-icon__image),
  .van-popup :deep(.van-icon__image),
  .van-popup :deep(.van-image__img) {
    border-radius: 8px !important;
  }
}

/* 优化英雄名称显示，特别是长名称 */
.hero-grid-item :deep(.van-grid-item__text) {
  font-size: 0.85rem;
  margin-top: 5px;
  width: 100%;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 2px;
  box-sizing: border-box;
}

/* 长名称特殊处理 */
.hero-long-name :deep(.van-grid-item__text) {
  font-size: 0.75rem;
  letter-spacing: -0.5px;
}

/* 调整图标大小和间距 */
.hero-grid-item :deep(.van-grid-item__icon) {
  margin-bottom: 2px;
}

/* 移动端适配 */
@media screen and (max-width: 375px) {
  .hero-grid-item :deep(.van-grid-item__text) {
    font-size: 0.75rem;
    margin-top: 3px;
  }
  
  .hero-long-name :deep(.van-grid-item__text) {
    font-size: 0.7rem;
    letter-spacing: -0.7px;
  }
  
  .hero-grid-item :deep(.van-grid-item__content) {
    padding: 8px 4px;
  }
}

/* 覆盖 vant 框架的 tab 文本省略样式 */
:deep(.van-tab__text--ellipsis) {
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: clip !important;
  display: inline-block !important;
  -webkit-line-clamp: unset !important;
  -webkit-box-orient: initial !important;
}

/* 趋势图样式 */
.trend-chart-popup {
  border-radius: 16px 16px 0 0 !important;
  overflow: hidden;
  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.1);
}

.trend-chart-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  background-color: #fff;
  overflow: hidden;
}

/* 顶部拖拽条 */
.trend-drag-bar {
  width: 36px;
  height: 4px;
  border-radius: 2px;
  background: #dcdee0;
  margin: 8px auto 0;
  flex-shrink: 0;
}

.trend-head {
  padding: 10px 40px 0 16px;
}

.trend-chart-title {
  font-size: 1.15rem;
  font-weight: 700;
  text-align: left;
  color: #1c1c1e;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.trend-chart-subtitle {
  font-size: 0.82rem;
  color: #969799;
  margin-top: 4px;
}

/* 趋势时间范围切换（分段控件） */
.trend-range-bar {
  display: flex;
  margin: 12px 16px 0;
  padding: 3px;
  border-radius: 8px;
  background: #f7f8fa;
  border: 1px solid #ebedf0;
  flex-shrink: 0;
}

.range-seg {
  flex: 1;
  text-align: center;
  padding: 7px 0;
  border-radius: 6px;
  font-size: 0.88rem;
  color: #646566;
  cursor: pointer;
}

.range-seg-active {
  color: #ee0a24;
  background: #fdecee;
  font-weight: 600;
}

/* 统计行：当前 / 区间涨跌 / 最低 */
.trend-stats {
  display: flex;
  padding: 14px 0 4px;
  flex-shrink: 0;
}

.trend-stat-item {
  flex: 1;
  text-align: center;
}

.trend-stat-mid {
  border-left: 1px solid #ebedf0;
  border-right: 1px solid #ebedf0;
}

.trend-stat-label {
  font-size: 0.78rem;
  color: #969799;
}

.trend-stat-value {
  font-size: 1.3rem;
  font-weight: 700;
  color: #1c1c1e;
  margin-top: 4px;
  font-variant-numeric: tabular-nums;
}

.stat-up {
  color: #ee0a24 !important;
}

.stat-down {
  color: #07c160 !important;
}

.stat-flat {
  color: #969799 !important;
}

.trend-chart {
  flex: 1;
  width: 100%;
  min-height: 240px;
  position: relative;
  padding: 4px 8px 0;
  box-sizing: border-box;
}

.chart-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 12px;
}

.loading-text {
  margin-top: 15px;
  font-size: 14px;
  color: #606266;
  font-weight: 500;
}

/* 趋势结论 */
.trend-insight {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 6px 16px calc(16px + env(safe-area-inset-bottom));
  font-size: 0.8rem;
  color: #646566;
  flex-shrink: 0;
}

.trend-insight .van-icon {
  color: #969799;
}

/* 优化关闭按钮 */
.trend-chart-popup :deep(.van-popup__close-icon) {
  color: #909399;
  font-size: 20px;
  top: 16px;
  right: 16px;
  z-index: 10;
}

.trend-chart-popup :deep(.van-popup__close-icon:active) {
  color: #f56c6c;
}

/* 趋势为空状态样式 */
.trend-empty {
  padding: 40px 0;
}

.trend-empty :deep(.van-empty__image) {
  width: 90px;
  height: 90px;
}

/* 底部改战区引流栏 */
.warzone-cta {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 90;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px calc(10px + env(safe-area-inset-bottom));
  background: linear-gradient(90deg, #2b2b3a, #3d2b3a);
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.2);
  cursor: pointer;
}

.cta-left {
  display: flex;
  flex-direction: column;
  line-height: 1.3;
}

.cta-title {
  color: #fff;
  font-size: 0.92rem;
  font-weight: 600;
}

.cta-sub {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.72rem;
}

.cta-btn {
  flex-shrink: 0;
  padding: 8px 18px;
  border-radius: 20px;
  background: linear-gradient(90deg, #ff6034, #ee0a24);
  color: #fff;
  font-size: 0.88rem;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(238, 10, 36, 0.4);
}

/* 吸顶容器样式 */
.sticky-container {
  position: sticky;
  top: 0;
  z-index: 100;
  height: 0;
  transition: height 0.3s ease;
  background-color: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(10px);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  width: 100%;
  box-sizing: border-box;
}

.sticky-container.sticky-active {
  height: 60px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

/* 吸顶状态下的英雄容器 */
.sticky-hero-container {
  display: flex;
  align-items: center;
  transition: transform 0.3s ease, opacity 0.3s ease;
  max-width: 45%;
}

/* 吸顶状态下的英雄头像 */
.sticky-hero-image {
  border: 2px solid white;
  transition: width 0.3s ease, height 0.3s ease;
}

/* 吸顶状态下的英雄名字 */
.sticky-hero-name {
  color: white;
  margin-left: 10px;
  display: flex;
  align-items: center;
  transition: font-size 0.3s ease, opacity 0.3s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sticky-hero-name .van-icon {
  margin-left: 5px;
}

/* 吸顶状态下的同步时间 */
.sticky-sync-time {
  color: white;
  transition: transform 0.3s ease, opacity 0.3s ease;
  opacity: 0;
  flex: 1;
  min-width: 160px;
  max-width: 55%;
  white-space: nowrap;
  overflow: hidden;
  text-align: right;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.sticky-sync-time .zl-query-time {
  margin: 0;
  padding-left: 8px;
  white-space: nowrap;
  font-size: 0.85rem;
  position: relative;
  display: inline-flex;
  align-items: center;
  height: 20px;
  line-height: 20px;
}

.sticky-sync-time .zl-query-time:after {
  content: "";
  position: absolute;
  width: 4px;
  height: 80%;
  background: red;
  border-radius: 2px;
  left: 0;
  top: 10%;
}

.sticky-sync-time .secondaryQuestionBtn {
  margin-left: 5px;
  border-radius: 10px;
  font-weight: bold;
  cursor: pointer;
  font-size: 0.85rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  opacity: 1 !important;
  vertical-align: middle;
  position: relative;
  top: 0;
  line-height: 20px;
  height: 20px;
}

/* 为了兼容吸顶效果，修改tabs的样式 */
.zl-body :deep(.van-tabs__wrap) {
  position: sticky;
  z-index: 99;
}
</style>
